import { PortalOverriddenLanguageModel } from "../../models";
import { Provider } from "@angular/core";
import { PortalLanguageService } from "./portal-language.service";
import { providePortalProductOverriddenLanguages } from "./portal-product-overridden-languages-provider";
import { PORTAL_LANGUAGE_SHOW_QUERY_PARAM_TOKEN } from "../../constants";

export function providePortalLanguageService(
  overriddenProductLanguages?: PortalOverriddenLanguageModel[],
  showLangParamInBrowserUrl?: boolean
): Provider[] {
  return [
    providePortalProductOverriddenLanguages(overriddenProductLanguages),
    {
      provide: PORTAL_LANGUAGE_SHOW_QUERY_PARAM_TOKEN,
      useValue: !!showLangParamInBrowserUrl,
    },
    PortalLanguageService,
  ];
}
